export const sex = {
  male: 'Чоловіча / Male',
  female: 'Жіноча / Female',
  undefined: 'Невизначено / Undefined',
};
